import { Step, StepLabel, Stepper } from '@material-ui/core';
import styles from './OrderHistoryWidget.module.css';

import { useState } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
const OrderHistoryWidget = ({ order, handler }) => {
  const [activeStep, setActiveStep] = useState(0);
  const [history, setHistory] = useState([]);
  const { t } = useTranslation();

  const steps = [
    t('orderDetails.historyWidget.accepted'),
    activeStep > 1
      ? t('orderDetails.historyWidget.paid')
      : order?.status === 'REJECTED_PAYMENT'
      ? t('orderDetails.historyWidget.unsuccessfulPayment')
      : t('orderDetails.historyWidget.paymentWaiting'),
    activeStep > 2
      ? t('orderDetails.historyWidget.invoiced')
      : order?.status === 'REJECTED_INVOICE'
      ? t('orderDetails.historyWidget.unsuccessfulInvoice')
      : t('orderDetails.historyWidget.invoiceWaiting'),
    activeStep < 3
      ? t('orderDetails.historyWidget.shippingWaiting')
      : order?.status === 'SHIPPING' && activeStep === 3
      ? t('orderDetails.historyWidget.shipping')
      : order?.status === 'REJECTED_DELIVERY' && activeStep === 3
      ? t('orderDetails.historyWidget.rejectedDelivery')
      : t('orderDetails.historyWidget.shipped'),
    activeStep < 4
      ? t('orderDetails.historyWidget.inProgress')
      : activeStep === 4
      ? t('orderDetails.historyWidget.lastSteps')
      : t('orderDetails.historyWidget.completed')

    // "Visszautasítva",
  ];

  const handleStepCount = () => {
    if (order?.status === 'PENDING' || order?.status === 'REJECTED_PAYMENT') {
      setActiveStep(1);
    }
    if (order?.status === 'PAID' || order?.status === 'REJECTED_INVOICE') {
      setActiveStep(2);
    }
    if (order?.status === 'INVOICED' || order?.status === 'SHIPPING' || order?.status === 'REJECTED_DELIVERY') {
      setActiveStep(3);
    }
    if (order?.status === 'SHIPPED') {
      setActiveStep(4);
    }
    if (order?.status === 'DONE') {
      setActiveStep(5);
    }
    // if (order?.status === "REJECTED") {
    //   setActiveStep(6);
    // }
  };

  useEffect(() => {
    handleStepCount();
    if (order?.orderHistories) {
      setHistory(order?.orderHistories);
    }
  }, [order]);

  return (
    <Stepper activeStep={activeStep} className={styles.stepper}>
      {steps.map((label, idx) => (
        <Step key={label}>
          {history.length < 1 ? (
            <StepLabel className={styles.stepperItems}>{label}</StepLabel>
          ) : (
            // <Tooltip
            //   title={
            //     history[idx] === undefined ? (
            //       <Typography>{label}</Typography>
            //     ) : (
            //       <>
            //         <Typography>{history[idx]?.message.split(':')}</Typography>
            //         <Typography>
            //           Date of changes:
            //           <br></br>
            //           {history[idx]?.updateAt && handler(history[idx]?.updateAt)}
            //         </Typography>
            //       </>
            //     )
            //   }
            //   arrow>
            <StepLabel
              className={
                (order?.status === 'REJECTED_PAYMENT' && idx === 1) ||
                (order?.status === 'REJECTED_INVOICE' && idx === 2) ||
                (order?.status === 'REJECTED_DELIVERY' && idx === 3)
                  ? styles.error
                  : styles.stepperItems
              }>
              {label}
            </StepLabel>
            // </Tooltip>
          )}
        </Step>
      ))}
    </Stepper>
  );
};

export default OrderHistoryWidget;
